import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firbase/firebase";


export const fetchCategories = createAsyncThunk(
    "categories/fetchCategories", 
    async () => {
    const querySnapshot = await getDocs(collection(db, "categories"));    

    return querySnapshot.docs.flatMap(doc => { 
        const data = doc.data();
        let result =  Object.entries(data).map(([name, value]) => ({
                id:doc.id,
                name,
                value,
        }))
        // debugger
        result = result.sort((a,b)=>a.value - b.value);

        console.log(result);
        
        return result;
        
    });
});

const categorySlice = createSlice({
    name: "categories",
    initialState: { categories: [], loading: false },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => { state.loading = true; })
            .addCase(fetchCategories.fulfilled, (state, action) => {                
                state.categories = action.payload;
                state.loading = false;
            })
            .addCase(fetchCategories.rejected, (state) => { state.loading = false; });
    }
});

export default categorySlice.reducer;




